import styled, { css } from 'styled-components';

import { ICustomScrollBarWrapperProps } from './CustomScrollBar.types';


const $trackColor = '#ECECEC',
      $thumbColor = '#868686';

export const ScrollBarHoveredCssCode = css<ICustomScrollBarWrapperProps>`
    &::-webkit-scrollbar-track {
        background-color: ${$trackColor}${({ isFading }) => isFading ? '96' : 'FF'};
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${$thumbColor + 'FF'};
    }

    &::-webkit-scrollbar-button {
      ${({ withButtons }) => withButtons ? `
            background-color: ${$thumbColor + 'FF'};
         ` : ''
        }
    }
`;
export const ScrollBarCssCode = css<ICustomScrollBarWrapperProps>`
  overflow: overlay;

  &::-webkit-scrollbar {
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;

    ${({ styles }) => styles && styles.root ? css(styles.root) : ''}
  }

  &::-webkit-scrollbar-track {
    background-color: ${$trackColor}${({ isFading }) => isFading ? '1A' : 'FF'};
    border-radius: 4px;

    ${({ styles }) => styles && styles.track ? css(styles.track) : ''}
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${$thumbColor}${({ isFading }) => isFading ? '4D' : 'FF'};
    border-radius: 4px;

    ${({ styles }) => styles && styles.thumb ? css(styles.thumb) : ''}
  }

  &::-webkit-scrollbar-button {
    ${({ withButtons, size, isFading, styles }) => withButtons ? `
            width: ${size}px;
            height: ${size}px;
            background-color: ${$thumbColor}${isFading ? '1A' : 'FF'};
            border-radius: 50%;
    
            ${styles && styles.button ? css(styles.button) : ''}
        ` : ``
    }
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const CustomScrollBarWrapper = styled.div<ICustomScrollBarWrapperProps>`
  position: relative;
  width: 100%;
  height: 100%;

  & .scrollable-pane .ms-ScrollablePane--contentContainer:hover {
    ${ScrollBarHoveredCssCode}
  }

  & .scrollable-pane .ms-ScrollablePane--contentContainer {
    ${ScrollBarCssCode}
  }
`;